module.exports = __webpack_public_path__ + "img/verify.065ae354.svg";